/*
 *
 * SSO Login API Sagas
 *
 */

/* eslint-disable no-constant-condition */

import { put, call, take } from 'redux-saga/effects';
import { legit } from 'apex-legit-service';
import { notAsked, loading, failure, success } from './actions';
import { MAKE_REQUEST } from './constants';
import apiRequest from './api';
import { LEGIT_SERVICE_CONFIG } from '../../containers/Login';
import { ALL_REQUESTED_PERMISSIONS } from '../../common';


export function* request(method, params) {
  try {
    // Set the status in the store to LOADING
    yield put(loading());
    // Make the request
    const results = yield call(apiRequest, method, params);
    // Save results to the store
    yield put(success(results));
  } catch (err) {
    // The .json() method turns the response body into a promise.
    const errorBody = yield err.response.json();
    errorBody.status = err.response.status;
    // Set status to FAILURE and pass along the error
    yield put(failure(errorBody));
  }
}

export function* ssoLoginFlow() {
  yield put(notAsked());
  while (true) {
    // When MAKE_REQUEST is dispatched, make a request.
    const action = yield take(MAKE_REQUEST);
    yield call(request, 'POST', action.params);
    yield call(legit.adoptExistingSession, LEGIT_SERVICE_CONFIG, ALL_REQUESTED_PERMISSIONS);
  }
}

export default ssoLoginFlow;



// WEBPACK FOOTER //
// ./src/services/SsoLogin/sagas.js